import {
  sendRequest
} from 'zoomforth_zfutils/xhr_tools.js';

import {
  getPageId
} from 'zoomforth_codesbane_editor/reducers/index.js';

import {
  makeSaveId,
  startSave,
  commitSave,
  failSave
} from 'zoomforth_shared_management/action_creators/saving.js';

import {
  notifyErrorMaybeLostData
} from './misc.js';

import {
  showModal
} from './editor_modals.js';

import ConfirmRevertToVersionModal
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/confirm_revert_to_version_container.jsx';

export const markAsDraft = ()=>
  (dispatch)=> {
    dispatch({ type: 'MARK_AS_DRAFT' });
    // Don't bother persisting the `isDraft` state to the server—
    // our API doesn't support that. Instead we rely on our changing of
    // the content item to update the page model draft state,
    // later, when we load the page model draft state is should be right.
  };

export const revertToVersion = (version)=>
  (dispatch, getState)=> {

    const pageId = getPageId(getState());

    const saveId = makeSaveId();
    dispatch(startSave('revert_to_version', saveId, `Revert to version ${version}`));

    sendRequest({
      url: `/rpc/pages/${pageId}/revert`,
      method: 'POST',
      params: { version },
      onSuccess: ()=> {
        dispatch(commitSave(saveId));
        window.location.reload();
      },
      onError: ({ status, responseText })=> {
        dispatch(failSave(saveId));
        dispatch(notifyErrorMaybeLostData(status, responseText));
      }
    });

  };

export const revertToPublished = ()=>
  ()=> {
    revertToVersion(null);
  };

export const confirmRevertToPublished = (version)=>
  (dispatch)=> {
    dispatch(showModal(ConfirmRevertToVersionModal, { version }));
  };
